import React from 'react';
import {useSelector,useDispatch} from 'react-redux'
import {EmptyMassage,SpinerLoad,ShowDiv,ShowDivshort,Flex,ButtonInput} from './comps'
import { SlLike,SlDislike} from 'react-icons/sl';
import { BsFillHandThumbsUpFill,BsEye} from 'react-icons/bs';
import { BiShare} from 'react-icons/bi';
import { FaRegComments} from 'react-icons/fa';
import * as normalActions from '../store/actions'
import { useAuthGate } from './authPrompt'
import { firstPostImage } from '../utils/postImages'
import UserAvatar from './userAvatar'

const AllType = props =>{
  const dispatch = useDispatch()
  const translations = useSelector(state => state.lang_reduse.lang);
  const { requireAuth, promptEl } = useAuthGate()
  const voteDelta = useSelector(state => (state.UpdsReduse.voteDelta || {})[String(props.id)] || { p: 0, d: 0 })
  const likeCount = Math.max(0, Number(props.vlikes || 0) + (Number(voteDelta.p) || 0))
  const dislikeCount = Math.max(0, Number(props.vdislikes || 0) + (Number(voteDelta.d) || 0))
  const like = () => { if (requireAuth()) dispatch(normalActions.add_to_upds('p', props.userid, props.id)) }
  const dislike = () => { if (requireAuth()) dispatch(normalActions.add_to_upds('d', props.userid, props.id)) }
  return(
    <div key={props.id} className='allType'>{promptEl}{props.type === 'i'? <img src={`/api/uploads/${firstPostImage(props.image)}`} />:<video controls><source src={`/api/uploads/${props.image}`} /></video>}

    <div className="mainBodyAll">
    <Flex>
      <ShowDiv icon={<i ><SlLike /></i>} is={2} title={likeCount} click={like} />
    <ShowDiv icon={<i ><SlDislike /></i>} is={2} title={dislikeCount} click={dislike} />
    <ShowDiv icon={<i ><BsEye /></i>} title={props.views} />
    <ButtonInput onChange={()=>{}} title="add" placeholder="enter your comment" value={()=>{}}  click={() =>{ requireAuth() }} height={'60%'} width={'40%'} />
    <ShowDiv icon={<i ><BiShare /></i>} title={translations.share} click={() => prompt('enter the reason')} />
    <ShowDiv icon={<i ><FaRegComments /></i>} title={props.vcomments} click={()=>{}} />
    </Flex></div>
    <div className='sideNav'>
      <ShowDivshort icon={<i><SlLike /></i>} is={2} title={likeCount} click={like} />
    <ShowDivshort icon={<i ><SlDislike /></i>} is={2} title={dislikeCount} click={dislike} />
    <ShowDivshort icon={<i><BsEye /></i>} title={props.views} />
    <ShowDivshort icon={<i><BiShare /></i>} title={translations.share} click={() => prompt('enter the reason')} />
    <ShowDivshort icon={<i><FaRegComments /></i>} title={props.vcomments} click={()=>{}} />
    </div>
    <div className='alltypeInfo'>
      <div onClick={props.gouser}><UserAvatar src={props.userImg} name={props.email} alt="d" />
      <h1>@{props.email}</h1></div>
      <p>{props.dis}</p>
      {/*<p className='t'>{props.hash}</p>*/}
    </div>
    333
    <div  className='alltypeComm'>coments</div>
    </div>
  )
}
export default AllType;
